import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Dot({ idVariant = '', className }: Props) {
  return (
    <IconBase name="dot" w={20} className={className}>
      <circle cx="10" cy="10" r="5" fill="currentColor"/>
    </IconBase>
  )
}

export default Dot
